import { render, staticRenderFns } from "./skipToNav.vue?vue&type=template&id=faa54052&scoped=true&"
import script from "./skipToNav.vue?vue&type=script&lang=ts&"
export * from "./skipToNav.vue?vue&type=script&lang=ts&"
import style0 from "./skipToNav.vue?vue&type=style&index=0&id=faa54052&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa54052",
  null
  
)

export default component.exports